import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=b9f02244"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9f02244')) {
      api.createRecord('b9f02244', component.options)
    } else {
      api.reload('b9f02244', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=b9f02244", function () {
      api.rerender('b9f02244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/return/inform/edit.vue"
export default component.exports